import React, { createContext, useState, useEffect } from 'react';
import axiosInstance from "./axiosConfig";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const savedUser = localStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) : null;
    });
   
    const login = (userData) => {
        const { Name, EmployeeID, Auth, Department  } = userData;
        const minimalUser = { Name, EmployeeID, Auth, Department  }; // Include Auth for routing
        setUser(minimalUser);
        localStorage.setItem('user', JSON.stringify(minimalUser));

        // Set session expiration (24 hours from now)
        const sessionExpiration = new Date(new Date().getTime() + 12 * 60 * 60 * 1000); // + 24 * 60 * 60 * 1000); // 24 hours
        localStorage.setItem('sessionExpiration', sessionExpiration.toISOString());
        // localStorage.setItem('loginTime', new Date().toISOString()); // Optional: store login time
    };

    /*const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('loginTime');
        localStorage.removeItem('sessionExpiration');
        localStorage.removeItem('userData');
    };*/

    const logout = async () => {
      try {
        // Call backend logout
        await axiosInstance.post('/api/logout', {}, { withCredentials: true });

        // Clear frontend
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('loginTime');
        localStorage.removeItem('sessionExpiration');
        localStorage.removeItem('userData');
      } catch (err) {
        console.error('Logout failed:', err);

        localStorage.removeItem('user');
        localStorage.removeItem('loginTime');
        localStorage.removeItem('sessionExpiration');
        localStorage.removeItem('userData');
      }
    };

    useEffect(() => {
        const checkSessionExpiration = async () => {
            const sessionExpiration = localStorage.getItem('sessionExpiration');
            if (!sessionExpiration) return;

            const currentTime = new Date();

            if (currentTime > new Date(sessionExpiration)) {
                await logout();
            }
        };

        // Check immediately
        checkSessionExpiration();

        // Check every 1 minute
        const interval = setInterval(() => {
            checkSessionExpiration();
        }, 60 * 1000);

        return () => clearInterval(interval);
    }, []);


    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
